import React from 'react'
import { Link } from 'react-router-dom'

export const ErrorPage = () => {
  return (
    <section className='error_page'>
      <div className="center">
        <Link to="/" className='btn primary'>Go Back To Home</Link>
        <h2>Page Not Found</h2>
      </div>
    </section>
  )
}
